import type { CalendarPeriod } from '@ui/components/calendar/picker'
import { differenceInMinutes } from 'date-fns'

const minutesInDay = 24 * 60

export function formatInventoryDuration(value: CalendarPeriod, t: (key: string) => string) {
  const totalMinutes = Math.max(0, differenceInMinutes(value.end, value.start))
  const days = Math.floor(totalMinutes / minutesInDay)
  const hours = Math.floor((totalMinutes % minutesInDay) / 60)
  const minutes = totalMinutes % 60
  const parts: string[] = []

  if (days) {
    parts.push(`${days} ${t('page.services.inventory.picker.day_short')}`)
  }
  if (hours) {
    parts.push(`${hours} ${t('page.services.inventory.picker.hour_short')}`)
  }
  if (minutes || !parts.length) {
    parts.push(`${minutes} ${t('page.services.inventory.picker.minute_short')}`)
  }

  return parts.join(' ')
}
